export const RAZORPAY_KEY = process.env.REACT_APP_RAZORPAY_KEY 